import { getInterface } from '@/utils/js/initVariable';
const prefixUrl = 'api/ExportDataApi/';
export const exportFootPrintMap = (data)=>{
  return getInterface.post(`${prefixUrl}exportFootPrintMap`, data);
}
export const exportFavorite = (data)=>{
  return getInterface.post(`${prefixUrl}exportFavorite`, data);
}
export const uploadData = (data)=>{
  return getInterface.postForm(`${prefixUrl}uploadData`, data);
}
export const queryExportDataTaskProgress = (data)=>{
  return getInterface.post(`${prefixUrl}queryExportDataTaskProgress`, data);
}
export const createExportDataTask = (data)=>{
  return getInterface.post(`${prefixUrl}createExportDataTask`, data);
}
export const download = (data)=>{
  return getInterface.bolbPost(`${prefixUrl}download/${data}`, data);
}
export const downloadV2 = (data)=>{
  return `${prefixUrl}downloadV2/${data}`;
}

export const exportWorkspace = (data)=>{
  return getInterface.post(`${prefixUrl}exportWorkspace`, data);
}
// 事件导出任务创建
export const exportMapEvent = (data)=>{
  return getInterface.post(`${prefixUrl}exportMapEvent`, data);
}
// 底图相关离线数据
export const exportOffline = (data)=>{
  return getInterface.post(`${prefixUrl}exportOffline`, data);
}
export const importOffline = (data)=>{
  return getInterface.postForm(`${prefixUrl}importOffline`, data);
}
// 线索区导出
export const exportClueArea = (data)=>{
  return getInterface.post(`${prefixUrl}exportClueArea`, data);
}